import { AxiosError } from "axios";

export const getErrorMessage = (error: AxiosError<any>): string => {
  if (error.response?.data?.slug) {
    return error.response.data.slug;
  }
  
  if (typeof error.response?.data === 'string') {
    return error.response.data;
  }
  
  if (error.response?.data?.message?.slug) {
    return error.response.data.message.slug;
  }
  
  if (typeof error.response?.data?.message === 'string') {
    return error.response.data.message;
  }
  
  if (error.response?.data?.error) {
    return error.response.data.error;
  }
  
  return "unknown-error";
};

// Base HTTP client configuration
export const createHttpConfig = (token?: string, contentType = 'application/json') => ({
  headers: {
    'Content-Type': contentType,
    ...(token && { Authorization: `Bearer ${token}` })
  }
});
